import React from "react";
import { Link } from "react-router-dom";
import { Container } from "reactstrap";
//@ts-ignore
import logo from "../../assets/logo-white.png";
//@ts-ignore
import aboutus from "../../assets/about-us.png";

export const AboutUs = () => {
  document.title = "Casino24 - About Us";
  return (
    <Container
      fluid
      className="m-0 flex flex-col min-h-full w-full items-center text-white"
    >
      <section className="w-full lg:w-[75%] lg:mt-[2rem] mb-1">
        <Link to="/">
          <img
            src={logo}
            alt="Casino24"
            className="object-cover w-[10rem] lg:w-[15rem] my-3 cursor-pointer"
          />
        </Link>
      </section>
      <section className="w-[90%] lg:w-[65%] my-2">
        <img
          alt="Preview"
          src={aboutus}
          className="rounded w-full object-fit h-[13rem] lg:h-[17rem] xl:h-[28rem]"
        />
      </section>
      <section className="flex flex-col w-[90%] lg:w-[50%] xl:w-[37%] my-2 text-justify text-md ">
        <h2 className="text-center font-bold text-2xl xl:text-3xl mt-4">
          About Casino24.com
        </h2>
        <p className="mb-5 mt-5">
          Welcome to Casino24.com, where we provide exclusive bonuses and
          raffles to our visitors. We are dedicated to providing a premium
          gaming experience to all of our users, and are committed to making
          sure our users have access to the latest and greatest in online casino
          gaming.
        </p>
        <p className="mb-5">
          Our team is made up of seasoned experts in the online gaming industry,
          who have years of experience working with some of the biggest names in
          the business. We have leveraged our expertise to create a
          user-friendly platform that offers a wide range of games, bonuses, and
          promotions, to ensure that there is something for everyone.
        </p>
        <p className="mb-5">
          We understand the importance of providing a safe and secure gaming
          environment for our users. That's why we have implemented strict
          security measures to protect the personal and financial information of
          our users. We use state-of-the-art encryption technology to ensure
          that all transactions are protected and that our users can enjoy their
          gaming experience without any worries.
        </p>
        <p className="mb-5">
          At Casino24.com, we offer a wide range of games, including slots,
          table games, and live dealer games. Our games are powered by some of
          the biggest names in the industry, including Microgaming, NetEnt, and
          Evolution Gaming, to ensure that our users have access to the latest
          and greatest in online gaming. We also provide access to a wide range
          of sports betting options, including live betting and pre-match
          betting, on a variety of sports such as football, basketball, tennis,
          and more.
        </p>
        <p className="mb-5">
          In addition to our wide range of games, we also offer exclusive
          bonuses and promotions to our users. From welcome bonuses to daily
          promotions, we make sure that our users have access to the best deals
          and offers available. We also host regular raffles, giving our users
          the opportunity to win big prizes and rewards.
        </p>
        <p className="mb-5">
          In conclusion, our online casino affiliate website is committed to
          providing a premium gaming experience to all of our users. We have
          brought together a team of experts and have leveraged our expertise to
          create a user-friendly platform that offers a wide range of games,
          bonuses, and promotions. So, whether you are a seasoned gambler or a
          newcomer to the world of online gaming, our website is the perfect
          place for you.
        </p>
        <p className="mb-5 font-bold">Safety First</p>
        <p className="mb-5 font-bold">
          We know you love to hit the top when we speak of fun. However, we also
          care about our clients. Safe gambling is highly important to protect
          you against gambling addiction. In addition to offering you sites with
          self-limiting options, we also offer contact information with the
          established organizations which can help you with your gambling
          problems, if any, of course.
        </p>
      </section>
    </Container>
  );
};
